export const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = date.toLocaleString("default", { month: "short" });
    const day = date.getDate().toString().padStart(2, "0"); 

    return `${day} ${month} ${year}`
}

export const formatTime = (dateString) => {
    const date = new Date(dateString.replace(" ", "T")); 
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
}

export const groupByFormattedDate = (arr, property) => {
    arr.forEach((item) => {
      const date = new Date(item.createdDate);
      const year = date.getFullYear();
      const month = date.toLocaleString("default", { month: "short" });
      const day = date.getDate().toString().padStart(2, "0");
  
      item.formattedDate = `${day} ${month} ${year}`;
      item.formattedCreatedDate = `${month} ${year}`;
    });
  
    return arr.reduce((acc, curr) => {
      const key = curr[property];
      if (!acc[key]) acc[key] = [];
      acc[key].push(curr);
      return acc;
    }, {});
  };